import LocalizationContainer from './LocalizationContainer';

export default LocalizationContainer;
